import * as React from "react";
import { Card } from "antd";
import moment from "moment";
import { sumStepDesc } from "./SumOrdered";
import {
  SumSteps,
  OrderSumItemsQuery_ordersSumItems_result
} from "src/__generated__/types";
import SimpleBarChart from "src/components/SimpleBarChart";

export interface SumResultCardProps {
  timeFormat: string;
  startTimeStamp: number | null;
  endTimeStamp: number | null;
  timeStep: SumSteps;
  item: OrderSumItemsQuery_ordersSumItems_result;
}

export default class SumResultCard extends React.Component<
  SumResultCardProps,
  never
> {
  public render() {
    return (
      <Card
        title={this.props.item.title}
        extra={
          <span>
            {`Sales from ${moment(this.props.startTimeStamp!).format(
              this.props.timeFormat
            )} to ${moment(this.props.endTimeStamp!).format(
              this.props.timeFormat
            )} grouped by ${sumStepDesc[this.props.timeStep]}`}
          </span>
        }
        key={this.props.item.title}
        style={{ marginTop: 30 }}
      >
        <div>
          <strong>Total orders: </strong>
          {this.props.item.quantity}
        </div>
        {this.props.item.timeLine && (
          <SimpleBarChart
            valueKey="total"
            labelKey="timeString"
            data={this.props.item.timeLine
              .filter(t => t != null)
              .map(t => ({
                timeStamp: t!.timeStamp,
                timeString: moment(t!.timeStamp).format("HH:mm"),
                total: t!.total
              }))}
          />
        )}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/SumResultCard.tsx